import { gql } from '@apollo/client';

export default gql`
  query notificationSettings {
    notificationSettings {
      enabled
      notificationType {
        id
        name
        description
        symbol
      }
      notificationTypeUser {
        id
        notificationTypeId
        enabled
      }
    }
  }
`;
